import SiteReducer from './SiteReducer';
import LayoutReducer from './LayoutReducer';

export default {
    site: SiteReducer,
    layout: LayoutReducer,
};
